/**
 * The type-to-confirm match rule for deleting a cloud environment.
 *
 * Its own module so the rule can be tested without mounting a dialog, and so
 * the dialog does not have to explain itself twice.
 */

/**
 * Whether what the user typed names the environment they are about to delete.
 *
 * Trimmed and case-insensitive on purpose. The guard exists to make the user
 * read the row and re-state WHICH environment is going — not to test their
 * typing. Environment names here run to "FOR-2200 display QA (fresh
 * provision)"; demanding an exact-case match of that would train people to
 * copy-paste the name, which defeats the read-it-back step entirely.
 */
function normalize(value: string): string {
  return value.trim().toLocaleLowerCase();
}

export function matchesEnvironmentConfirmation(typed: string, environmentName: string): boolean {
  // An unnamed environment must never be deletable by submitting an empty box.
  // `target` is null between openings and the dialog renders `?? ""`, so this
  // is a reachable state, not a theoretical one.
  if (normalize(environmentName) === "") return false;
  return normalize(typed) === normalize(environmentName);
}
